import { render } from "./HeroiconsSolidCollection.vue?vue&type=template&id=18bd1cd6"
const script = {}

import exportComponent from "/home/nginx/domains/panel.vip-mod.net/vendor/laravel/nova/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"HeroiconsSolidCollection.vue"]])

export default __exports__